import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

const findDataMiDt = createAsyncThunk(
  "fichaMiDt/findDataMiDt",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { data } = await axiosInstance.post(`${api.baseURL}contract/midt-get`, {
        fichas: [state.fichaMiDt.recordText],
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default findDataMiDt;
